import React from 'react';
import DashboardStatsCards from './DashboardStatsCards';
import DashboardGraphs from './DashboardGraphs';
import DashboardStatGraphs from './DashboardStatGraphs';
import {
  AdminPage,
  AdminPageHeader,
  AdminPageTitle,
  AdminSection,
} from '../common/AdminPrimitives';

const DashboardComponent: React.FC = () => {
  return (
    <AdminPage>
      <AdminPageHeader>
        <AdminPageTitle>대시보드</AdminPageTitle>
      </AdminPageHeader>

      <AdminSection>
        <DashboardStatsCards />
      </AdminSection>

      <AdminSection>
        <DashboardGraphs />
      </AdminSection>

      <AdminSection>
        <DashboardStatGraphs />
      </AdminSection>
    </AdminPage>
  );
};

export default DashboardComponent;
